import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Radio,
  Tabs,
  Tooltip,
  Table,
  Switch,
  Result,
  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { GlobalSet, StyledTab, Styled, PaperBlockList } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchProductDetails,
  editProduct,
  deleteProduct,
  getPendingQuantityProductSizes,
  getProductDetails,
  getPendingQuantityProductSizesByPly,
} from "../../../Services/productServices";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import {
  getAllGradesForConfig,
  getGradeQualitiesForConfig,
} from "../../../Services/settingsServices";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { getUnitData } from "../../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits,
  conversionFactorUnitsToTonne,
  conversionFactorTonneToUnits,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { toFixedValue } from "../../../Utils/helper/helper";
import OrdersTable from "./OrdersTable";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices.js";
import EmptyState from "../../../Components/EmptyState/emptyState";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getOrdersListForCreateNewSol } from "../../../Services/orderServices.js";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer.jsx";
import { ToleranceResetModal } from "../../../Components/Modal/ToleranceResetModal.jsx";
import styled from "styled-components";

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const Panes = Tabs.TabPane;

const runTypes = [
  { label: "All Sizes", value: "allSizes" },
  { label: "Selected Sizes", value: "selectedSizes" },
];
const CustomHeader=styled.div`
.ant-page-header-heading-left{
align-items: flex-start;
}
.sc-gdyeKB ebJfcX{
width: 100% !important;
}
`
const CreateNewSolution = ({
  onClickCreateSolution,
  formValuesForStock,
  jobCardDetails,
  backButtonClicked,
  stockSizesArray,
  setStockSizesArray,
  createNewSolutionFormValuesForSizes,
  ordersIdList,
  updateOrdersIdList,
  type,
  optimizePartition,
  minimizeOverfulfillment,
  onOptimizePartitionChange,
  onMinimizeOverfulfillmentChange,

  unselectedOrders,
  machineData,
  jobId,
  solutionId,
  completeJCDetails,
  solutionType = "",
  dynamicStock = [],
  dummy_orders = false,
  so_number =null
}) => {
  const location = useLocation();
  const [form] = Form.useForm();
  const { Option } = Select;
  const deckleWidthData = ["cm", "mm"];
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [tabKey, setTabKey] = useState();
  const [formValues, setFormValues] = useState({});
  const [stockSizes, setStockSizes] = useState(stockSizesArray);
  const [isAvailableQuantityUsed, setIsAvailableQuantityUsed] = useState(
    stockSizesArray.length > 0
  );
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  // console.log(unselectedOrders);
  // console.log(jobCardDetails);
  const [plannedReels, setPlannedReels] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [allowedQuantityerrorText, setAllowedQuantityerrorText] =
    useState(false);
  const [unitData, setUnitData] = useState();
  const [deckleUnit, setDeckleUnit] = useState();
  const [errorToastr, setErrorToastr] = useState(false);
  const [isDynamicStock, setIsDynamicStock] = useState(false);
  const [sizeErrorToastr, setSizeErrorToastr] = useState(false);
  const [orderIdList, setOrderIdList] = useState(
    Array.isArray(ordersIdList)
      ? ordersIdList
      : jobCardDetails?.group?.orders
          ?.filter((data) => data.item_type === "order")
          .map((data) => data.order_id)
  );
  const [orderToastr, setOrderToastr] = useState(false);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [ordersList, setOrdersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toleranceModal, setToleranceModal] = useState(false);
  const [globalTolerance, setGlobalTolerance] = useState({
    lower: 0,
    upper: 0,
  });
  const [showAlert, setShowAlert] = useState({
    isOrderChanged: false,
    isToleranceChanged: false,
    isGlobalToleranceChanged: false,
    isGlobalReelODChanged: false,
    isReelODChanged: false,
    toleranceLevel:"",
    isReelOrderChanged:false
  });
  const [isJobCardReelODEditModal, setJobCardReelODEditModal] = useState(false);
  const [globalReelOD,setGlobalReelOD] = useState({
    level:"Order",
    type:"",
    min_reel_od:0,
    max_reel_od:0,
    unit:"",
    selectedReelOD:[],
  })

  // StrictMode-safe / duplicate-call guards
  const didInitRef = useRef(false);
  const didApplyInitialSelectedSizesRef = useRef(false);
  const ordersFetchInFlightRef = useRef(false);
  const lastOrdersFetchKeyRef = useRef("");

  const columnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "3%",
      fixed: "left",
      align: "left",
      render: (text) => (text ? `${toHandlePOName(text)}` : "-"),
    },
    // {
    //   title: "Group No.",
    //   dataIndex: "groupno",
    //   width: "3%",
    //   fixed: "left",
    //   align:'left',
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "2%",
      fixed: "left",
      align: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) =>
        record?.category === "so" ? (
          "-"
        ) : (
          <div className="actionBtn2">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={`${record.customercode}-${record.customer_name}`}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                {record?.customer_alias || "-"}
              </Tooltip>
            </Styled>
          </div>
        ),
    },

    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "4.5%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "2%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "2.5%",
      align: "left",
    },

    {
      title: "Order Qty",
      dataIndex: "quantityValue",
      width: "3.4%",
      align: "left",
      render: (text, record) => (
        <div>
          {record.quantityValue && record.quantityValue.includes("\n")
            ? record.quantityValue.split("\n").map((line, index) => (
                <div
                  key={index}
                  style={{ fontSize: index === 0 ? "smaller" : "default" }}
                >
                  {line}
                </div>
              ))
            : record.quantityValue}
        </div>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
  ];

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add new records to view details here ";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    if (Array.isArray(ordersIdList)) {
      setOrderIdList(ordersIdList);
      return;
    }
    setOrderIdList(
      jobCardDetails?.group?.orders
        ?.filter((data) => data.item_type === "order")
        .map((data) => data.order_id) || []
    );
  }, [ordersIdList, jobCardDetails]);

  // Rehydrate machine-details fields (including units) whenever the upstream defaults change.
  // The main init effect below is mount-guarded (StrictMode-safe), but this panel can be opened
  // multiple times without unmounting, so we must keep these fields in sync.
  useEffect(() => {
    if (!formValuesForStock) return;
    if (!formValuesForStock?.units) return;
    form.setFieldsValue({
      cutters: formValuesForStock?.maximum_cutters,
      min_deckle_length: formValuesForStock?.min_deckle_length,
      max_deckle_length: formValuesForStock?.max_deckle_length,
      min_width: formValuesForStock?.left_edge_trim,
      max_width: formValuesForStock?.right_edge_trim,
      effective_deckle_length: formValuesForStock?.effective_deckle_length,
      deckleLengthUnit: formValuesForStock?.units?.deckle_size_ub,
      widthUnit: formValuesForStock?.units?.right_edge_trim,
    });
    setDeckleUnit(formValuesForStock?.units?.effective_deckle_length);
  }, [form, formValuesForStock, jobId, solutionId]);

  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;
    (async () => {
      setLoading(true);
      let req = {
        group_id: jobCardDetails?.group?.group_id,
        filter: [],
        fetch_type: "all",
        jobcard_id: jobId,
        erp_state: "complete",
        dummy_orders :dummy_orders,
        so_number: so_number
      };
      const reqKey = JSON.stringify(req);
      if (ordersFetchInFlightRef.current || lastOrdersFetchKeyRef.current === reqKey) {
        setLoading(false);
      } else {
        ordersFetchInFlightRef.current = true;
        lastOrdersFetchKeyRef.current = reqKey;
      }

      getOrdersListForCreateNewSol(req, "")
        .then((response) => {
          setOrdersList(response.data);
          setEmptyStateLabel("noData");
        })
        .catch((error) => {
          console.log("error", error);
          setEmptyStateLabel("connectionAPIError");
        })
        .finally(() => {
          setLoading(false);
          ordersFetchInFlightRef.current = false;
        });

      let deckleMangtSettings = await getWorkflowSettings("deckle_management");

      setIsDynamicStock(deckleMangtSettings?.data?.dynamic_stocks?.value);
      // console.log(formValuesForStock);
      form.setFieldsValue({
        cutters: formValuesForStock?.maximum_cutters,
        min_deckle_length: formValuesForStock?.min_deckle_length,
        max_deckle_length: formValuesForStock?.max_deckle_length,
        min_width: formValuesForStock?.left_edge_trim,
        max_width: formValuesForStock?.right_edge_trim,
        effective_deckle_length: formValuesForStock?.effective_deckle_length,
        deckleLengthUnit: formValuesForStock?.units.deckle_size_ub,
        widthUnit: formValuesForStock?.units.right_edge_trim,
        // optimizie_partitions: location?.state?.optimize_unique_partitions
        //   ? location?.state?.optimize_unique_partitions
        //   : false,
      });
      setDeckleUnit(formValuesForStock?.units.effective_deckle_length);
      const unitResponse = await getUnitData();
      setUnitData(unitResponse.data);
      getProductDetails(jobCardDetails.product.code)
        .then((response) => {
          setProductData({
            bulk: `${response.data.bulk}`,
            gsm: `${response.data.gsm}`,
          });
        })
        .catch((error) => {
          console.log("Error in getting product specification list");
        });
      // Always load regular stocks and merge with preserved dynamic stocks
      getPendingQuantityProductSizesByPly(
        jobCardDetails.product.code,
        jobCardDetails.group.ply
      )
          .then((response) => {
            const data = response.data?.map((item) => {
              let size = item.grain === "Long Grain" ? item.width : item.length;
              if (item.type === "reel") {
                size = item.width;
              }

              const processWeight = item.sheet_in_process.sheet_data?.reduce(
                (n, { fulfilled_weight }) => n + fulfilled_weight,
                0
              );
              const completedWeight = item.sheet_completed.sheet_data?.reduce(
                (n, { fulfilled_weight }) => n + fulfilled_weight,
                0
              );
              const productionWeight =
                item.sheet_in_production.sheet_data?.reduce(
                  (n, { fulfilled_weight }) => n + fulfilled_weight,
                  0
                );

              return {
                size: size,
                stockSizeId: item.id,
                stockSize:
                  item.type === "reel"
                    ? +item.width
                    : +item.width + " * " + +item.length,
                stockDefaultSize:
                  item.units.width ===
                  unitResponse.data.units_management.length.default
                    ? ""
                    : item.type === "reel"
                    ? +(
                        item.width *
                        CoversionFactorUnitsToCM[item.units.width] *
                        CoversionFactorCMToUnits[
                          unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " " +
                      lengthUnit[
                        unitResponse.data.units_management.length.default
                      ].displayName.toUpperCase()
                    : +(
                        item.width *
                        CoversionFactorUnitsToCM[item.units.width] *
                        CoversionFactorCMToUnits[
                          unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " * " +
                      +(
                        item.length *
                        CoversionFactorUnitsToCM[item.units.length] *
                        CoversionFactorCMToUnits[
                          unitResponse.data.units_management.length.default
                        ]
                      ).toFixed(3) +
                      " " +
                      lengthUnit[
                        unitResponse.data.units_management.length.default
                      ].displayName.toUpperCase(),
                availableLimit: parseFloat(
                  item.quantity -
                    (item.in_process +
                      item.in_production +
                      item.completed +
                      processWeight +
                      productionWeight +
                      completedWeight) *
                      conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                allowedQuantity: parseFloat(
                  item.quantity -
                    (item.in_process +
                      item.in_production +
                      item.completed +
                      processWeight +
                      productionWeight +
                      completedWeight) *
                      conversionFactorTonneToUnits[item.units.quantity]
                ).toFixed(3),
                availableDefaultLimit:
                  item.units.quantity ===
                  unitResponse.data.units_management.weight.default
                    ? ""
                    : (
                        parseFloat(
                          item.quantity -
                            (item.in_process +
                              item.in_production +
                              item.completed +
                              processWeight +
                              productionWeight +
                              completedWeight) *
                              conversionFactorTonneToUnits[item.units.quantity]
                        ) *
                        conversionFactorUnitsToTonne[item.units.quantity] *
                        conversionFactorTonneToUnits[
                          unitResponse.data.units_management.weight.default
                        ]
                      ).toFixed(3) +
                      " " +
                      capitalize(
                        weightUnit[
                          unitResponse.data.units_management.weight.default
                        ].displayName
                      ),
                plannedWeightError: "",
                allowedQuantityError: "",
                units: item.units,
                availableUnit: item.units.quantity,
                type: item.type,
                isSelected: solutionType == 'replan' && jobCardDetails?.group?.orders.find((data) => data.size == item.width) ? true : false
              };
            });

            const stocksData = data?.filter(
              (data) => data.availableLimit > 0 && data.type == "reel"
            );

            // Preserve existing dynamic stocks from current stockSizes (only if they belong to this job card)
            const existingDynamicStocks = stockSizes.filter(stock => stock.isNew || stock.isRequired);
            
            if (solutionType == "replan") {
              if (dynamicStock.length) {
                // Merge existing dynamic stocks with solution dynamic stocks for this job card
                const allDynamicStocks = [...existingDynamicStocks, ...dynamicStock];
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                // Keep existing dynamic stocks for this job card
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else if (solutionId == "1" || solutionId == "2") {
              let data =
                solutionId == "1"
                  ? jobCardDetails.solution_1.data.orders
                  : jobCardDetails.solution_2.data.orders;
              const dynamicStockData = data
                ?.filter((order) => {
                  return order.creation_type === "dynamic" || order.creation_type === "required";
                })
                .map((item) => {
                  return {
                    allowedQuantity: item?.requirement,
                    stockSize: item.size,
                    isSelected: true,
                    ...( item.creation_type === "dynamic" && {isNew: true}),
                    ...( item.creation_type === "required" && {isRequired: true,
                      weight_lb : item.requirement_lb,
                      weight_ub : item.requirement_ub,
                      priority_stock : item.priority_stock,
                    }),
                    isEdit: false,
                    units: {
                      quantity: item?.units?.fulfilled_weight,
                      width: item?.units?.size,
                      weight_lb : item?.units?.requirement_lb ,
                      weight_ub : item?.units?.requirement_ub,
                    },
                  };
                });

              // Merge existing dynamic stocks with solution dynamic stocks for this job card
              const allDynamicStocks = [...existingDynamicStocks, ...dynamicStockData];
              if (allDynamicStocks.length) {
                setStockSizes([...stocksData, ...allDynamicStocks]);
              } else {
                setStockSizes([...stocksData, ...existingDynamicStocks]);
              }
            } else {
              // Keep existing dynamic stocks for this job card
              setStockSizes([...stocksData, ...existingDynamicStocks]);
            }
          })
          .catch((error) => {
            console.log("Error in getting pending quantity product sizes");
          });
    })();
  }, []);

  useEffect(() => {
    // Apply saved/previous selected sizes exactly once after stockSizes are available.
    if (didApplyInitialSelectedSizesRef.current) return;
    if (!stockSizes?.length) return;
    if (!createNewSolutionFormValuesForSizes?.selectedSizes?.length) return;

    didApplyInitialSelectedSizesRef.current = true;
    stockSizes.forEach((stockSize, index) => {
      const sizeDetails =
        createNewSolutionFormValuesForSizes?.selectedSizes?.filter(
          (size) => size.stockSizeId == stockSize.stockSizeId
        );
      if (sizeDetails && sizeDetails.length > 0) {
        onAllowedQuantityChange(
          parseFloat(sizeDetails[0].allowedQuantity),
          parseFloat(sizeDetails[0].stockSize),
          index
        );
      }
    });
  }, [stockSizes, createNewSolutionFormValuesForSizes]);

  useEffect(() => {
    let updatedTableContent = ordersList ? getAllOrders() : [];
    setCompletedOrders(updatedTableContent);
  }, [ordersList]);

  const getAllOrders = () => {
    let updatedTableContect = ordersList.map((order) => {
      // Calculate quantityValue based on your conditions
      let quantityValue;
      if (order.type === "reel" && order.quantity_type === "reel_sheet") {
        quantityValue =
          order.this_item_type === "order"
            ? Math.round(order.quantity) + " " + "Reels"
            : Math.round(order.no_of_reel_sheet) + " " + "Reels";
      } else if (
        order.type === "sheet" &&
        order.quantity_type === "reel_sheet"
      ) {
        quantityValue =
          order.weight +
          " " +
          capitalize(weightUnit[order.units.planned_weight]?.displayName);
        quantityValue +=
          "\n" + Math.round(order.no_of_reel_sheet) + " " + "Sheets";
      } else if (
        (order.type === "reel" || order.type === "sheet") &&
        order.quantity_type === "weight"
      ) {
        quantityValue =
          order.weight +
          " " +
          capitalize(weightUnit[order.units.weight]?.displayName);
      }

      const width = order.width?.toFixed(3);
      const length = order.length?.toFixed(3);
      const widthDisplay = Number.isInteger(order.width) ? order.width : width;
      const lengthDisplay = Number.isInteger(order.length)
        ? order.length
        : length;
      const size = `${widthDisplay}${
        order.length ? `x${lengthDisplay}` : ""
      } ${lengthUnit[order.units.width]?.displayName?.toUpperCase()}`;
      const balance_qty = (order.balance_weight == 0)?"-":order.balance_weight+" "+capitalize(order.units.weight)

      return {
        key: `${order.uuid}`,
        pono: `${order.category === "so" ? order.so : order.po}`,
        sono: `${order.so}`,
        category: order.category,
        groupno: `${order.split_group ? order.split_group : "-"}`,
        orderno: `${order.number}`,

        productcode: `${order.product}`,
        productspec: `${order.product_spec}`,
        customercode: `${order.customer}`,
        type: capitalize(order.type),
        size: size,
        customer_name: `${order.customer_name}`,
        customer_alias: `${order.customer_alias}`,
        units: order.units,
        // quantityValue = order.this_item_type == "i"
        quantityValue: quantityValue,
        width: order.width,
        grain: order.grain,
        length: order.length,
        order_type: order.type,
        balance_qty: balance_qty,
      };
    });

    return updatedTableContect;
  };

  const onClickCreateSolutionButton = async () => {
    await setUpdatedFormValues();
    form.submit();
  };

  const setUpdatedFormValues = () => {
    let updatedFormValues = formValues;
    updatedFormValues["status"] = form.getFieldValue("status");
    updatedFormValues["selectedSizes"] = [];
    let temp = stockSizes.filter(
      (item) =>
        item.isSelected == true && item.allowedQuantity && item.stockSize
    );
    temp.forEach((item) => {
      var index = stockSizes.findIndex(
        (obj) => obj.stockSizeId == item.stockSizeId
      );

      let selectedSizes = {
        stockSizeId: item.isNew || item.isRequired ? "" : stockSizes[index].stockSizeId,
        stockSize: item.stockSize,
        allowedQuantity: item.allowedQuantity,

        plannedWeight: item.allowedQuantity,
        creation_type: item.isNew ? "dynamic" : item.isRequired ? 'required' : "static",
        type: "reel",
        availableUnit: item.availableUnit,
         ...(item.isRequired && {
            weight_lb : parseFloat( item.weight_lb),
            weight_ub: parseFloat(item.weight_ub),
            priority_stock : item.priority_stock ? true : false,
          }),
        units: {
          size: item.units.width,
          planned_weight: item.units.quantity,
          allowed_quantity: item.units.quantity,
           ...(item.isRequired && {
            weight_lb : item.units.weight_lb,
            weight_ub: item.units.weight_ub,
          }),
        },
      };
      if (jobCardDetails?.group?.machines[0]?.machine_type !== "rewinder")
        selectedSizes = {
          ...selectedSizes,
          reels: form.getFieldValue("reels" + index),
        };
      updatedFormValues.selectedSizes.push(selectedSizes);
    });
    updatedFormValues["minDeckleLength"] =
      form.getFieldValue("min_deckle_length");
    updatedFormValues["maxDeckleLength"] =
      form.getFieldValue("max_deckle_length");
    updatedFormValues["deckleLengthUnit"] =
      form.getFieldValue("deckleLengthUnit");
    updatedFormValues["minWidth"] = form.getFieldValue("min_width");
    updatedFormValues["maxWidth"] = form.getFieldValue("max_width");
    updatedFormValues["widthUnit"] = form.getFieldValue("widthUnit");
    updatedFormValues["effectiveDeckleLength"] = form.getFieldValue(
      "effective_deckle_length"
    );
    updatedFormValues["effectiveDeckleLengthUnit"] = deckleUnit;
    updatedFormValues["cutters"] = form.getFieldValue("cutters");
    // updatedFormValues["optimizie_partitions"] = optimizePartition;
    setFormValues(updatedFormValues);
  };

  const handleTabChange = async (key) => {
    await setUpdatedFormValues();
    setTabKey(key);
  };

  const onFinish = async (e) => {
    // let updatedFormValues = formValues;
    // if (tabKey == 1) {
    //   updatedFormValues['status'] = e.status;
    //   updatedFormValues['selectedSizes'] = [];
    //   let temp = stockSizes.filter(item => item.isSelected == true);
    //   temp.forEach(item => {
    //     var index = stockSizes.findIndex((obj) => obj.stockSize == item.stockSize);

    //     let selectedSizes = {
    //       stockSizeId: stockSizes[index].stockSizeId,
    //       stockSize: item.stockSize,
    //       allowedQuantity: e['allowed-quantity' + index],
    //       reels: e['reels' + index],
    //       plannedWeight: e['planned-weight' + index]
    //     }
    //     updatedFormValues.selectedSizes.push(selectedSizes);
    //   })
    //   setFormValues(updatedFormValues);
    // }
    // else {
    //   updatedFormValues['minDeckleLength'] = e.min_deckle_length;
    //   updatedFormValues['maxDeckleLength'] = e.max_deckle_length;
    //   updatedFormValues['deckleLengthUnit'] = e.deckleLengthUnit;
    //   updatedFormValues['minWidth'] = e.min_width;
    //   updatedFormValues['maxWidth'] = e.max_width;
    //   updatedFormValues['widthUnit'] = e.widthUnit;
    //   updatedFormValues['effectiveDeckleLength'] = e.effective_deckle_length;
    //   updatedFormValues['cutters'] = e.cutters;
    // }
    // setFormValues(updatedFormValues);
    // let erroredStocks = stockSizes.filter(
    //   (stockSize) =>
    //     stockSize.plannedWeightError != "" ||
    //     stockSize.allowedQuantityError != ""
    // );
    // if (erroredStocks && erroredStocks.length == 0) {
    setStockSizesArray(stockSizes);
    const newSelectedSizes = formValues.selectedSizes.map((value) => {
      if (parseFloat(value.plannedWeight) > parseFloat(value.allowedQuantity)) {
        return {
          ...value,
          plannedWeight: value.allowedQuantity,
        };
      } else return value;
    });
    if (formValues.selectedSizes.length)
      formValues.selectedSizes = newSelectedSizes;
    if (orderIdList && orderIdList.length) onClickCreateSolution(formValues);
    else {
      setOrderToastr(true);
      setTimeout(() => {
        setOrderToastr(false);
      }, 3000);
    } //}
  };

  const handleRunTypeChange = (e) => {
    if (e.target.value == "allSizes") {
      let tempStockSizes = [...stockSizes];
      tempStockSizes.map((stockSize, index) => {
        let sizeDetails =
          createNewSolutionFormValuesForSizes?.selectedSizes.filter(
            (size) => size.stockSizeId == stockSize.stockSizeId
          );
        if (sizeDetails && sizeDetails.length > 0) {
          onAllowedQuantityChange(
            sizeDetails[0].allowedQuantity,
            sizeDetails[0].stockSize,
            index
          );
        } else {
          onAllowedQuantityChange(
            stockSize.availableLimit,
            stockSize.size,
            index
          );
        }
        stockSize.isSelected = true;
      });
      // setStockSizes(stockSizes.map(stockSize => ({...stockSize, isSelected: true})))
      setStockSizes(tempStockSizes);
    } else {
      setStockSizes(
        stockSizes.map((stockSize) => ({ ...stockSize, isSelected: false }))
      );
    }
  };

  const handleSwitchChange = (index) => {
    setSwitchTooltip(!switchTooltip);
    let temp = [...stockSizes];
    onAllowedQuantityChange(
      temp[index].availableLimit,
      temp[index].size,
      index
    );
    temp[index].isSelected = !stockSizes[index].isSelected;
    setStockSizes(temp);
  };

  const handleEdit = (index) => {
    setSwitchTooltip(!switchTooltip);
    let temp = [...stockSizes];
    onAllowedQuantityChange(
      temp[index].availableLimit,
      temp[index].size,
      index
    );
    temp[index].isEdit = !stockSizes[index].isEdit;
    setStockSizes(temp);
  };

  const changeDeckleLength = () => {
    // setDeckleUnit(form.getFieldValue("deckleLengthUnit"));
    const result =
      form.getFieldValue("max_deckle_length") *
        CoversionFactorUnitsToCM[form.getFieldValue("deckleLengthUnit")] -
      form.getFieldValue("min_width") *
        CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")] -
      form.getFieldValue("max_width") *
        CoversionFactorUnitsToCM[form.getFieldValue("widthUnit")];

    form.setFieldsValue({
      effective_deckle_length: (
        result * CoversionFactorCMToUnits[deckleUnit]
      ).toFixed(3),
    });

    // if (result < 0) {
    //   form.setFieldsValue({
    //     min_width: "",
    //     max_width: "",
    //     effective_deckle_length: "",
    //   });
    //   setShowError({
    //     error: true,
    //     message: `Total edge trim cannot be greater than deckle width`,
    //   });
    // } else {
    //   setShowError({
    //     error: false,
    //   });
    //   form.setFieldsValue({ effective_deckle_length: result.toFixed(3) });
    // }
  };

  const onAllowedQuantityChange = (value, size, index) => {
    if (
      conversionFactorUnitsToTonne[stockSizes[index].units.quantity] *
        parseFloat(stockSizes[index].availableLimit) <
      conversionFactorUnitsToTonne[
        form.getFieldValue(`allowed-quantity_unit${index}`)
      ] *
        parseFloat(value)
    ) {
      let updatedStocks = stockSizes;
      stockSizes[index].allowedQuantityError =
        "Allowed Qty should be less than or equal to Available Limit";
      setStockSizes(updatedStocks);
    } else {
      let updatedStocks = stockSizes;
      stockSizes[index].allowedQuantityError = "";
      setStockSizes(updatedStocks);
    }
    // calculatePlannedReels(
    //   size,
    //   +value,
    //   +productData.bulk,
    //   jobCardDetails.group.grouping_params.core_id,
    //   jobCardDetails.group.grouping_params.reel_od,
    //   index
    // );
    // calculatePlannedWeight(
    //   size,
    //   +productData.bulk,
    //   jobCardDetails.group.grouping_params.reel_od,
    //   jobCardDetails.group.grouping_params.core_id,
    //   index
    // );
  };

  const onSaveChages = async (index) => {
    try {
      // Wait for form validation to finish
      await form.validateFields([`allowed-quantity${index}`, `size${index}`,]);

      if(stockSizes[index].isRequired)
      {
        await form.validateFields([`lower_limit${index}`, `upper_limit${index}`,]);

      }
      const currentConvertedSize =
        CoversionFactorUnitsToCM[form.getFieldValue(`size_unit${index}`)] *
        parseFloat(form.getFieldValue(`size${index}`));

      const isDuplicate = stockSizes.some((data, idx) => {
        const convertedSize =
          CoversionFactorUnitsToCM[data.units.width] *
          parseFloat(data.stockSize);
        return idx !== index && convertedSize === currentConvertedSize;
      });

      if (isDuplicate) {
        setSizeErrorToastr(true);
        setTimeout(() => {
          setSizeErrorToastr(false);
        }, 3000);
        return;
      }

      let updatedStocks = [...stockSizes];
      updatedStocks[index].allowedQuantity = form.getFieldValue(
        `allowed-quantity${index}`
      );
      updatedStocks[index].stockSize = form.getFieldValue(`size${index}`);
      updatedStocks[index].units.quantity = form.getFieldValue(
        `allowed-quantity_unit${index}`
      );
      updatedStocks[index].isEdit = false;
      updatedStocks[index].units.width = form.getFieldValue(
        `size_unit${index}`
      );
    updatedStocks[index].weight_lb = form.getFieldValue(`lower_limit${index}`);
      updatedStocks[index].units.weight_lb = form.getFieldValue(
        `lower_unit${index}`
      );
      updatedStocks[index].weight_ub = form.getFieldValue(`upper_limit${index}`);
      updatedStocks[index].units.weight_ub = form.getFieldValue(
        `upper_unit${index}`
      );
      setStockSizes([...updatedStocks]);
    } catch (err) {
      // Validation failed
      setErrorToastr(true);
      setTimeout(() => {
        setErrorToastr(false);
      }, 3000);
    }
  };

  const onDiscardChages = (index) => {
    let updatedStocks = [...stockSizes];
    if (stockSizes[index].isNew || stockSizes[index].isRequired) {
      updatedStocks.splice(index, 1);

      const values = form.getFieldsValue();

      // 2. Rebuild form values with correct index
      const newValues = {};

      updatedStocks.forEach((item, idx) => {
        newValues[`size${idx}`] =
          values[`size${idx >= index ? idx + 1 : idx}`] || "";
        newValues[`allowed-quantity${idx}`] =
          values[`allowed-quantity${idx >= index ? idx + 1 : idx}`] || "";
        newValues[`size_unit${idx}`] =
          values[`size_unit${idx >= index ? idx + 1 : idx}`] || "";
        newValues[`allowed-quantity_unit${idx}`] =
          values[`allowed-quantity_unit${idx >= index ? idx + 1 : idx}`] || "";
          newValues[`lower_limit${idx}`] =
          values[`lower_limit${idx >= index ? idx + 1 : idx}`] || "";
          newValues[`lower_unit${idx}`] =
          values[`lower_unit${idx >= index ? idx + 1 : idx}`] || "";
          newValues[`upper_limit${idx}`] =
          values[`upper_limit${idx >= index ? idx + 1 : idx}`] || "";
          newValues[`upper_unit${idx}`] =
          values[`upper_unit${idx >= index ? idx + 1 : idx}`] || "";
      });
      newValues[`size${updatedStocks.length}`] = "";
      newValues[`allowed-quantity${updatedStocks.length}`] = "";
      newValues[`size_unit${updatedStocks.length}`] =
        unitData.units_management.length.default;
      newValues[`allowed-quantity_unit${updatedStocks.length}`] =
        unitData.units_management.weight.default;
        newValues[`lower_limit${updatedStocks.length}`] = "";
          newValues[`lower_unit${updatedStocks.length}`] = unitData.units_management.weight.default;;
          newValues[`upper_limit${updatedStocks.length}`] = "";
          newValues[`upper_unit${updatedStocks.length}`] = unitData.units_management.weight.default;
      form.setFieldsValue(newValues);
    } else {
      updatedStocks[index].isEdit = false;
      const newValues = {};
      newValues[`size${index}`] = stockSizes[index].stockSize;
      newValues[`allowed-quantity${index}`] = stockSizes[index].allowedQuantity;
      newValues[`size_unit${index}`] = stockSizes[index].units.width;
      newValues[`allowed-quantity_unit${index}`] =
        stockSizes[index].units.quantity;
        if(stockSizes[index].isRequired)
        {
          newValues[`lower_limit${index}`] = stockSizes[index].weight_lb;
          newValues[`lower_unit${index}`] = stockSizes[index].units.weight_lb;
          newValues[`upper_limit${index}`] = stockSizes[index].weight_ub;
          newValues[`upper_unit${index}`] =
           stockSizes[index].units.weight_ub;
        }
      form.setFieldsValue(newValues);
    }

    setStockSizes(updatedStocks);
  };

  const onAddStock = () => {
    let updatedStocks = [...stockSizes];
    let stock = {
      allowedQuantity: "",
      stockSize: "",
      isSelected: true,
      isNew: true,
      isEdit: true,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
      },
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

   const onAddRequiredStock = () => {
    let updatedStocks = [...stockSizes];
    let stock = {
      allowedQuantity: "",
      stockSize: "",
      isSelected: true,
      isRequired: true,
      isEdit: true,
      weight_lb : '',
      weight_ub: '',
      priority_stock : false,
      units: {
        quantity: unitData.units_management.weight.default,
        width: unitData.units_management.length.default,
        weight_lb: unitData.units_management.weight.default,
        weight_ub: unitData.units_management.weight.default,
      },
    };
    updatedStocks.push(stock);

    setStockSizes([...updatedStocks]);
  };

  const calculatePlannedReels = (size, weight, bulk, coreOd, reelOd, index) => {
    const value =
      (parseFloat(
        weight * conversionFactorUnitsToTonne[stockSizes[index].units.quantity]
      ) *
        1000 *
        1000 *
        parseFloat(bulk) *
        4) /
      (3.14 *
        parseFloat(
          size * CoversionFactorUnitsToCM[stockSizes[index].units.width]
        ) *
        (Math.pow(
          parseFloat(
            reelOd *
              CoversionFactorUnitsToCM[
                jobCardDetails.group.grouping_params.units.reel_od
              ]
          ),
          2
        ) -
          Math.pow(
            parseFloat(
              coreOd *
                CoversionFactorUnitsToCM[
                  jobCardDetails.group.grouping_params.units.core_id
                ]
            ),
            2
          )));
    // if (validateData.quantity !== "reel") {
    setPlannedReels(value.toFixed(3));
    form.setFieldsValue({ [`reels${index}`]: Math.floor(value.toFixed(3)) });
    // } else form.setFieldsValue({ no_of_reel_sheet: "" });
  };

  const calculatePlannedWeight = (size, bulk, reelOd, coreOd, index) => {
    const value =
      (3.14 *
        parseFloat(
          size * CoversionFactorUnitsToCM[stockSizes[index].units.width]
        ) *
        (Math.pow(
          parseFloat(
            reelOd *
              CoversionFactorUnitsToCM[
                jobCardDetails.group.grouping_params.units.reel_od
              ]
          ),
          2
        ) -
          Math.pow(
            parseFloat(
              coreOd *
                CoversionFactorUnitsToCM[
                  jobCardDetails.group.grouping_params.units.core_id
                ]
            ),
            2
          )) *
        parseFloat(form.getFieldValue("reels" + index))) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    form.setFieldsValue({
      [`planned-weight${index}`]: (
        value * conversionFactorTonneToUnits[stockSizes[index].units.quantity]
      ).toFixed(3),
    });
    const plannedWeightValue = (value * conversionFactorTonneToUnits[stockSizes[index].units.quantity]).toFixed(3);
    const shouldError =
      parseFloat(stockSizes[index].availableLimit) < parseFloat(plannedWeightValue) &&
      jobCardDetails?.group?.machines[0]?.machine_type !== "rewinder";
    setStockSizes((prevStocks) =>
      prevStocks.map((stock, i) =>
        i === index
          ? {
              ...stock,
              plannedWeightError: shouldError
                ? "Planned Weight should be less than or equal to Available Limit"
                : "",
            }
          : stock
      )
    );
  };
  const handleSwitchChange2 = (isChecked) => {
    // const isChecked = e.target.checked;
    onOptimizePartitionChange(isChecked);
    // location?.state?.optimize_unique_partitions = checked;
  };
  const handleSwitchChange3 = (isChecked) => {
    // const isChecked = e.target.checked;
    onMinimizeOverfulfillmentChange(isChecked);
    // location?.state?.optimize_unique_partitions = checked;
  };

  const refresh = () => {
    setLoading(true);
    let req = {
      group_id: jobCardDetails?.group?.group_id,
      filter: [],
      fetch_type: "all",
      jobcard_id: jobId,
      erp_state: "complete",
    };
    const reqKey = JSON.stringify(req);
    if (ordersFetchInFlightRef.current || lastOrdersFetchKeyRef.current === reqKey) {
      setLoading(false);
      return;
    }
    ordersFetchInFlightRef.current = true;
    lastOrdersFetchKeyRef.current = reqKey;

    getOrdersListForCreateNewSol(req, "")
      .then((response) => {
        setOrdersList(response.data);
        setEmptyStateLabel("noData");
      })
      .catch((error) => {
        console.log("error", error);
        setEmptyStateLabel("connectionAPIError");
      })
      .finally(() => {
        setLoading(false);
        ordersFetchInFlightRef.current = false;
      });
  };
  const onClickSetToleranceButton = () => {
    if(orderIdList.length!=0)
      setToleranceModal(!toleranceModal);
    else
    {  
      setOrderToastr(true);
      setTimeout(()=>setOrderToastr(false),2300);
    }
  };

  const changePriority = (e, index) => {
  const { checked } = e.target;

  setStockSizes((prevStocks) =>
    prevStocks.map((stock, i) =>
      i === index ? { ...stock, priority_stock: checked } : stock
    )
  );
};

  return unitData && deckleUnit ? (
    <RightLayoutContainer id="right-layout-container">
        <CustomHeader>
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0" }}>
       
        <PageHeader
          ghost={false}
          onBack={() => backButtonClicked()}
          title={
            solutionType == "replan" ? "Replan Job Card" : "Create new solution"
          }
          extra={[
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
              }}
            >
              {tabKey === "3" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      onClick={onClickSetToleranceButton}
                    >
                      <Iconmoon icon="set" size={15} color="#EA655B" />
                      Set Tolerance
                    </Button>
                    {showAlert.isGlobalToleranceChanged &&<span
                      className="failedJobMessage"
                      style={{
                        marginTop:"0px"
                      }}
                    >
                      <div style={{display: "flex", alignItems: "center",gap:"5px"}}>
                        {  showAlert.isGlobalToleranceChanged &&
                          (showAlert.isToleranceChanged ||
                            showAlert.isOrderChanged) && showAlert.toleranceLevel === "JobCard" && (
                            <Tooltip
                              placement="bottomRight"
                              title={
                                "Tolerance applied earlier do not apply to the newly selected/edited orders. Click 'Set Tolerance' again to update."
                              }
                            >
                              <Iconmoon
                                icon="warning-icon"
                                size={14}
                                color="#EA655B"
                              />
                              </Tooltip>
                          )}
                       {globalTolerance.lower!==0 && globalTolerance.upper!==0 && showAlert.toleranceLevel === "JobCard" &&<div> 
                        LB <strong>{globalTolerance.lower}%</strong>
                        {"    "}
                        <span style={{paddingLeft:"5px"}}/>
                        UB <strong>{globalTolerance.upper}%</strong>
                        </div>}
                      </div>
                    </span>}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      key="2"
                      className="themeBtn noBg"
                      onClick={() => {
                        if(orderIdList.length!=0)
                          setJobCardReelODEditModal(true)
                        else
                        {
                          setOrderToastr(true);
                          setTimeout(()=>setOrderToastr(false),2000);
                        }
                      }
                    }
                    >
                      <Iconmoon icon="set" size={15} color="#EA4E2C" />
                      Set Reel OD
                    </Button>
                    {globalReelOD.level == "JobCard" && 
                      <span className="failedJobMessage" style={{marginTop:"0px",display:"flex",alignItems:"center",gap:"3px"}}>
                        {showAlert.isGlobalReelODChanged &&
                          (showAlert.isReelODChanged ||
                            showAlert.isReelOrderChanged) && 
                          <Tooltip
                            placement="bottomRight"
                            title={
                              "Reel dimensions applied earlier do not apply to the newly selected/edited orders. Click 'Set Reel OD' again to update."
                            }
                          >
                            <Iconmoon
                              icon="warning-icon"
                              size={14}
                              color="#EA655B"
                            />
                          </Tooltip>
                        }
                        {globalReelOD.type == "Constant" 
                        ?<span>
                          {globalReelOD.selectedReelOD[0]}
                          {globalReelOD.selectedReelOD.length > 1 &&
                            <Tooltip
                              placement="bottomRight"
                              title={
                                ()=>{
                                  let text="";
                                  globalReelOD.selectedReelOD.slice(1).forEach(item=>text=text+" "+item);
                                  return text;
                                }
                              }
                            >
                              <span>{`  & ${globalReelOD.selectedReelOD.length-1}more`}</span>
                            </Tooltip>
                          }
                        </span>
                        :<span>{`${globalReelOD.min_reel_od} ${globalReelOD.unit} - ${globalReelOD.max_reel_od} ${globalReelOD.unit}`}</span>}
                      </span>
                    }
                  </div>
                </>
              )}
              <Button
                key="3"
                className="themeBtn"
                onClick={onClickCreateSolutionButton}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Create Solution
              </Button>
            </div>,
          ]}
        ></PageHeader>
       
      </PageTitleComp>
       </CustomHeader>
      <Form
        form={form}
        name="basic"
        autoComplete="off"
        className="haberLogin"
        onFinish={onFinish}
        onFinishFailed={(error) => {
          console.log("Form Error", error);
        }}
        initialValues={{
          remember: true,
        }}
      >
        <div className="groupedTabed">
          <StyledTab>
            <Tabs
              defaultActiveKey="1"
              onChange={handleTabChange}
              style={{ padding: "0px 0px 20px 0px" }}
            >
              <Panes tab="Stock Size" key="1">
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={14}>
                          <div
                            className="boxFieldTitle"
                            style={{ marginTop: "20px" }}
                          >
                            <label>Select Run Type</label>
                            <p>
                              Select if you would like to include specific sizes
                              quantity or let the system decide the optimum size
                              and quantity
                            </p>
                          </div>
                        </Col>
                        <Col span={10}>
                          <div
                            className="boxFormType switchRadio extraWidth"
                            style={{
                              justifyContent: "flex-end",
                              display: "flex",
                              marginTop: "20px",
                            }}
                          >
                            <Form.Item
                              name="status"
                              className=""
                              initialValue={
                                createNewSolutionFormValuesForSizes?.status
                                  ? createNewSolutionFormValuesForSizes?.status
                                  : "selectedSizes"
                              }
                            >
                              <Radio.Group
                                options={runTypes}
                                onChange={handleRunTypeChange}
                                optionType="button"
                                buttonStyle="solid"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={[16, 16]} className="groupForm">
                        <Col span={24} className="blockBreak centerAlign">
                          <PaperBlockList>
                            <Row style={{ width: "100%" }}>
                              <Col span={10}>
                                <div
                                  className="boxFieldTitle removeStar"
                                  style={{ marginTop: "20px" }}
                                >
                                  <label>Select Stock Sizes</label>
                                  <p>
                                    Select the sizes and quantity to process
                                    with orders
                                  </p>
                                </div>
                              </Col>
                              <Col span={14}>
                                <>
                                  {stockSizes.map((stockSize, index) => {
                                    return !stockSize.isNew && !stockSize.isRequired ? (
                                      <Row className="centerAlign">
                                        <Row style={{ width: "100%" }}>
                                          <Col span={18}>
                                            <div className=" removeStar">
                                              <label>
                                                {stockSize.stockSize +
                                                  " " +
                                                  lengthUnit[
                                                    stockSize.units.width
                                                  ].displayName.toUpperCase() 
                                                  // +
                                                  // (stockSize.stockDefaultSize
                                                  //   ? " ( " +
                                                  //     stockSize.stockDefaultSize +
                                                  //     " )"
                                                  //   : "")
                                                    }
                                              </label>
                                              {!stockSize.isEdit && (
                                                <p>
                                                  <span
                                                    style={{
                                                      width: "180px",
                                                      display: "inline-block",
                                                    }}
                                                  >
                                                    Available Limit :{" "}
                                                    {stockSize.availableLimit +
                                                      " " +
                                                      capitalize(
                                                        weightUnit[
                                                          stockSize
                                                            .availableUnit
                                                        ].displayName
                                                      ) +
                                                      (stockSize.availableDefaultLimit
                                                        ? " ( " +
                                                          stockSize.availableDefaultLimit +
                                                          " )"
                                                        : "")}
                                                  </span>
                                                  <span>
                                                    Allowed Limit :{" "}
                                                    {stockSize.allowedQuantity +
                                                      " " +
                                                      capitalize(
                                                        weightUnit[
                                                          stockSize.units
                                                            .quantity
                                                        ].displayName
                                                      )}
                                                  </span>
                                                </p>
                                              )}
                                            </div>
                                          </Col>
                                          <Col span={6}>
                                            <div className="actionBtn">
                                              {!stockSize.isEdit && (
                                                <GlobalSet
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                  }}
                                                >
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={"Edit Stock"}
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Button
                                                        className="textTypeBtn "
                                                        onClick={() =>
                                                          handleEdit(index)
                                                        }
                                                        style={{ right: "8" }}
                                                      >
                                                        <Iconmoon
                                                          icon="edit"
                                                          size={16}
                                                          color="#A19F9D"
                                                        />
                                                      </Button>
                                                    </Tooltip>
                                                  </Styled>
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={
                                                        stockSize.isSelected
                                                          ? "Remove Stock"
                                                          : "Add Stock"
                                                      }
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Switch
                                                        checked={
                                                          stockSize.isSelected
                                                        }
                                                        onChange={() =>
                                                          handleSwitchChange(
                                                            index
                                                          )
                                                        }
                                                        className="switch-new"
                                                        disabled={false}
                                                      />
                                                    </Tooltip>
                                                  </Styled>
                                                </GlobalSet>
                                              )}
                                            </div>
                                          </Col>
                                        </Row>

                                        {stockSize.isEdit && (
                                          <>
                                          <Row
                                            style={{ width: "100%" }}
                                            className=" "
                                          >
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Size"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`size${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.stockSize
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Size"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                        readOnly
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`size_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.width
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,
                                                          cursor: "not-allowed",
                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        open={false}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={null}
                                                      >
                                                        {unitData.units_management.length.data.map(
                                                          (length) => (
                                                            <Option
                                                              key={length}
                                                            >
                                                              {
                                                                lengthUnit[
                                                                  length
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Allowed Limit"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                  extra={
                                                    <span
                                                      style={{
                                                        color:
                                                          "var(--para-text)",
                                                        fontSize: "12px",
                                                        fontFamily:
                                                          "var(--sf-pro-text) !important",
                                                      }}
                                                    >
                                                      Available Limit:{" "}
                                                      {stockSize.availableLimit}{" "}
                                                      {weightUnit[
                                                        stockSize.availableUnit
                                                      ]?.displayName?.toUpperCase()}
                                                    </span>
                                                  }
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`allowed-quantity${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                        {
                                                          validator: (
                                                            _,
                                                            value
                                                          ) => {
                                                            if (
                                                              conversionFactorUnitsToTonne[
                                                                stockSize.units
                                                                  .quantity
                                                              ] *
                                                                parseFloat(
                                                                  stockSize.availableLimit
                                                                ) <
                                                              conversionFactorUnitsToTonne[
                                                                form.getFieldValue(
                                                                  `allowed-quantity_unit${index}`
                                                                )
                                                              ] *
                                                                parseFloat(
                                                                  value
                                                                )
                                                            ) {
                                                              return Promise.reject(
                                                                "Allowed Qty should be less than or equal to Available Limit"
                                                              );
                                                            } else {
                                                              return Promise.resolve();
                                                            }
                                                          },
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.allowedQuantity
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Allowed Limit"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                        onChange={(e) =>
                                                          onAllowedQuantityChange(
                                                            e.target.value,
                                                            stockSize.size,
                                                            index
                                                          )
                                                        }
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`allowed-quantity_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.quantity
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,

                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                        onChange={() => {
                                                          form.validateFields([
                                                            `allowed-quantity${index}`,
                                                          ]);
                                                        }}
                                                      >
                                                        {unitData.units_management.weight.data.map(
                                                          (weight) => (
                                                            <Option
                                                              key={weight}
                                                            >
                                                              {
                                                                weightUnit[
                                                                  weight
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col span={4}>
                                              <div
                                                className="boxFormType"
                                                style={{
                                                  marginBottom: "0",
                                                  marginTop: "33px",
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <Tooltip
                                                  title={
                                                    "Save the entered value"
                                                  }
                                                >
                                                  <Button
                                                    key="1"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                      marginRight: "10px",
                                                    }}
                                                    onClick={() =>
                                                      onSaveChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="check"
                                                      size={18}
                                                      color="#3FBD61"
                                                    />
                                                  </Button>
                                                </Tooltip>

                                                <Tooltip
                                                  title={"Discard the changes"}
                                                >
                                                  <Button
                                                    key="2"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                    }}
                                                    onClick={() =>
                                                      onDiscardChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="cancel"
                                                      size={18}
                                                      color="red"
                                                    />
                                                  </Button>
                                                </Tooltip>
                                              </div>
                                            </Col>
                                          </Row>
                                          
                                          </>
                                        )}
                                        {isDynamicStock &&
                                          index == stockSizes.length - 1 && (
                                            <GlobalSet
                                              style={{ marginTop: "20px",
                                                display: "flex",
                                                flexWrap: "wrap",   // makes it responsive (wraps on small screens)
                                                gap: "16px", 
                                               }}
                                            >
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add new stock
                                              </Button>
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddRequiredStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add required stock
                                              </Button>
                                            </GlobalSet>
                                          )}
                                      </Row>
                                    ): stockSize.isRequired ? (
                                      <Row className="centerAlign">
                                       <Row style={{ width: "100%" }}>
                                          <Col span={18}>
                                            <div className=" removeStar">
                                              <label>
                                                {stockSize.stockSize
                                                  ? stockSize.stockSize +
                                                    " " +
                                                    lengthUnit[
                                                      stockSize.units.width
                                                    ].displayName.toUpperCase()
                                                  : "New Required Stock"}
                                              </label>
                                              {!stockSize.isEdit && (
                                                <p>
                                                  <span>
                                                    Allowed Limit :{" "}
                                                    {stockSize.allowedQuantity +
                                                      " " +
                                                      capitalize(
                                                        weightUnit[
                                                          stockSize.units
                                                            .quantity
                                                        ].displayName
                                                      )}
                                                  </span>
                                                </p>
                                              )}
                                            </div>
                                          </Col>
                                          <Col span={6}>
                                            <div className="actionBtn">
                                              {!stockSize.isEdit && (
                                                <GlobalSet
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                  }}
                                                >
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={"Edit Stock"}
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Button
                                                        className="textTypeBtn "
                                                        onClick={() =>
                                                          handleEdit(index)
                                                        }
                                                        style={{ right: "8" }}
                                                      >
                                                        <Iconmoon
                                                          icon="edit"
                                                          size={16}
                                                          color="#A19F9D"
                                                        />
                                                      </Button>
                                                    </Tooltip>
                                                  </Styled>
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={
                                                        stockSize.isSelected
                                                          ? "Remove Stock"
                                                          : "Add Stock"
                                                      }
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Switch
                                                        checked={
                                                          stockSize.isSelected
                                                        }
                                                        onChange={() =>
                                                          handleSwitchChange(
                                                            index
                                                          )
                                                        }
                                                        className="switch-new"
                                                        disabled={false}
                                                      />
                                                    </Tooltip>
                                                  </Styled>
                                                </GlobalSet>
                                              )}
                                            </div>
                                          </Col>
                                        </Row>


                                        {stockSize.isEdit && (
                                          <>
                                          <Row
                                            style={{ width: "100%" , marginBottom: '20px'}}
                                            className=" "
                                          >
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Size"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`size${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.stockSize
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Size"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`size_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.width
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,
                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                      >
                                                        {unitData.units_management.length.data.map(
                                                          (length) => (
                                                            <Option
                                                              key={length}
                                                            >
                                                              {
                                                                lengthUnit[
                                                                  length
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Allowed Limit"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`allowed-quantity${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.allowedQuantity
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Allowed Limit"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                        onChange={(e) => {
                                                          if(form.getFieldValue([
                                                            `lower_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `lower_limit${index}`,
                                                          ]);
                                                          if(form.getFieldValue([
                                                            `upper_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `upper_limit${index}`,
                                                          ]);
                                                          }
                                                        }
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`allowed-quantity_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.quantity
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,

                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                        onChange={(e) => {
                                                          if(form.getFieldValue([
                                                            `lower_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `lower_limit${index}`,
                                                          ]);
                                                          if(form.getFieldValue([
                                                            `upper_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `upper_limit${index}`,
                                                          ]);
                                                          }
                                                        }
                                                      >
                                                        {unitData.units_management.weight.data.map(
                                                          (weight) => (
                                                            <Option
                                                              key={weight}
                                                            >
                                                              {
                                                                weightUnit[
                                                                  weight
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col span={4}>
                                              <div
                                                className="boxFormType"
                                                style={{
                                                  marginBottom: "0",
                                                  marginTop: "33px",
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <Tooltip
                                                  title={
                                                    "Save the entered value"
                                                  }
                                                >
                                                  <Button
                                                    key="1"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                      marginRight: "10px",
                                                    }}
                                                    onClick={() =>
                                                      onSaveChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="check"
                                                      size={18}
                                                      color="#3FBD61"
                                                    />
                                                  </Button>
                                                </Tooltip>

                                                <Tooltip
                                                  title={"Delete the stock"}
                                                >
                                                  <Button
                                                    key="2"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                    }}
                                                    onClick={() =>
                                                      onDiscardChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="cancel"
                                                      size={18}
                                                      color="red"
                                                    />
                                                  </Button>
                                                </Tooltip>
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row
                                            style={{ width: "100%" }}
                                            className=" "
                                          >
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Lower Limit"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`lower_limit${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                        {
                                                          validator: (
                                                            _,
                                                            value
                                                          ) => {
                                                            if (
                                                              conversionFactorUnitsToTonne[
                                                                form.getFieldValue(
                                                                  `allowed-quantity_unit${index}`
                                                                )
                                                              ] *
                                                                parseFloat(
                                                                  form.getFieldValue(
                                                                  `allowed-quantity${index}`
                                                                )
                                                                ) <
                                                              conversionFactorUnitsToTonne[
                                                                form.getFieldValue(
                                                                  `lower_unit${index}`
                                                                )
                                                              ] *
                                                                parseFloat(
                                                                  value
                                                                )
                                                            ) {
                                                              return Promise.reject(
                                                                "Lower limit should be less than or equal to Allowed Quantity"
                                                              );
                                                            } else {
                                                              return Promise.resolve();
                                                            }
                                                          },
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.weight_lb
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Lower Limit"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,

                                                        }}
                                                        
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`lower_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.weight_lb
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,
                                                          //cursor: "not-allowed",
                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                         suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                       // open={false}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        onChange={(e) => {
                                                          if(form.getFieldValue([
                                                            `lower_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `lower_limit${index}`,
                                                          ]);
                                                           }
                                                        }
                                                      >
                                                        {unitData.units_management.weight.data.map(
                                                          (weight) => (
                                                            <Option
                                                              key={weight}
                                                            >
                                                              {
                                                                weightUnit[
                                                                  weight
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Upper Limit"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                  // extra={
                                                  //   <span
                                                  //     style={{
                                                  //       color:
                                                  //         "var(--para-text)",
                                                  //       fontSize: "12px",
                                                  //       fontFamily:
                                                  //         "var(--sf-pro-text) !important",
                                                  //     }}
                                                  //   >
                                                  //     Available Limit:{" "}
                                                  //     {stockSize.availableLimit}{" "}
                                                  //     {weightUnit[
                                                  //       stockSize.availableUnit
                                                  //     ]?.displayName?.toUpperCase()}
                                                  //   </span>
                                                  // }
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`upper_limit${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                         {
                                                          validator: (
                                                            _,
                                                            value
                                                          ) => {
                                                            if (
                                                              conversionFactorUnitsToTonne[
                                                                form.getFieldValue(
                                                                  `allowed-quantity_unit${index}`
                                                                )
                                                              ] *
                                                                parseFloat(
                                                                  form.getFieldValue(
                                                                  `allowed-quantity${index}`
                                                                )
                                                                ) >
                                                              conversionFactorUnitsToTonne[
                                                                form.getFieldValue(
                                                                  `upper_unit${index}`
                                                                )
                                                              ] *
                                                                parseFloat(
                                                                  value
                                                                )
                                                            ) {
                                                              return Promise.reject(
                                                                "Upper limit should be greater than or equal to Allowed Quantity"
                                                              );
                                                            } else {
                                                              return Promise.resolve();
                                                            }
                                                          },
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.weight_ub
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Upper Limit"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                        // onChange={(e) =>
                                                        //   onAllowedQuantityChange(
                                                        //     e.target.value,
                                                        //     stockSize.size,
                                                        //     index
                                                        //   )
                                                        // }
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`upper_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.weight_ub
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,

                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                        onChange={(e) => {
                                                         
                                                          if(form.getFieldValue([
                                                            `upper_limit${index}`,
                                                          ]))
                                                          form.validateFields([
                                                            `upper_limit${index}`,
                                                          ]);
                                                          }
                                                        }
                                                      >
                                                        {unitData.units_management.weight.data.map(
                                                          (weight) => (
                                                            <Option
                                                              key={weight}
                                                            >
                                                              {
                                                                weightUnit[
                                                                  weight
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                          
                                          </Row>
                                          <Row
                                          style={{ width: "100%" }}
                                            className=" ">
                                            <div className="checklist-address">
                                                                          <Checkbox
                                                                            type="checkbox"
                                                                            value={stockSize.priority_stock}
                                                                            checked={stockSize.priority_stock}
                                                                           onChange={(e) => changePriority(e, index)}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                fontSize: "12px",
                                                                                fontStyle: "normal",
                                                                                lineHeight: "20px",
                                                                                fontFamily: "var(--sf-pro-text)",
                                                                                color: "var(--para-text)",
                                                                                margin: "0",
                                                                              }}
                                                                            >
                                                                              It’s a Priority Stock
                                                                            </span>
                                                                          </Checkbox>
                                                                        </div>
                                          </Row>
                                          </>
                                        )}
                                        {isDynamicStock &&
                                          index == stockSizes.length - 1 && (
                                            <GlobalSet
                                              style={{ marginTop: "20px",
                                                display: "flex",
                                                flexWrap: "wrap",   // makes it responsive (wraps on small screens)
                                                gap: "16px", 
                                               }}
                                            >
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add new stock
                                              </Button>
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddRequiredStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add required stock
                                              </Button>
                                            </GlobalSet>
                                          )}
                                      </Row>
                                    )  :  (
                                      <Row className="centerAlign">
                                        <Row style={{ width: "100%" }}>
                                          <Col span={18}>
                                            <div className=" removeStar">
                                              <label>
                                                {stockSize.stockSize
                                                  ? stockSize.stockSize +
                                                    " " +
                                                    lengthUnit[
                                                      stockSize.units.width
                                                    ].displayName.toUpperCase()
                                                  : "New Stock"}
                                              </label>
                                              {!stockSize.isEdit && (
                                                <p>
                                                  <span>
                                                    Allowed Limit :{" "}
                                                    {stockSize.allowedQuantity +
                                                      " " +
                                                      capitalize(
                                                        weightUnit[
                                                          stockSize.units
                                                            .quantity
                                                        ].displayName
                                                      )}
                                                  </span>
                                                </p>
                                              )}
                                            </div>
                                          </Col>
                                          <Col span={6}>
                                            <div className="actionBtn">
                                              {!stockSize.isEdit && (
                                                <GlobalSet
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                  }}
                                                >
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={"Edit Stock"}
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Button
                                                        className="textTypeBtn "
                                                        onClick={() =>
                                                          handleEdit(index)
                                                        }
                                                        style={{ right: "8" }}
                                                      >
                                                        <Iconmoon
                                                          icon="edit"
                                                          size={16}
                                                          color="#A19F9D"
                                                        />
                                                      </Button>
                                                    </Tooltip>
                                                  </Styled>
                                                  <Styled>
                                                    <Tooltip
                                                      placement="bottomRight"
                                                      title={
                                                        stockSize.isSelected
                                                          ? "Remove Stock"
                                                          : "Add Stock"
                                                      }
                                                      getPopupContainer={(
                                                        triggerNode
                                                      ) => triggerNode}
                                                    >
                                                      <Switch
                                                        checked={
                                                          stockSize.isSelected
                                                        }
                                                        onChange={() =>
                                                          handleSwitchChange(
                                                            index
                                                          )
                                                        }
                                                        className="switch-new"
                                                        disabled={false}
                                                      />
                                                    </Tooltip>
                                                  </Styled>
                                                </GlobalSet>
                                              )}
                                            </div>
                                          </Col>
                                        </Row>

                                        {stockSize.isEdit && (
                                         <>
                                         <Row
                                            style={{ width: "100%" }}
                                            className=" "
                                          >
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Size"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`size${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.stockSize
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Size"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`size_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.width
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,
                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                      >
                                                        {unitData.units_management.length.data.map(
                                                          (length) => (
                                                            <Option
                                                              key={length}
                                                            >
                                                              {
                                                                lengthUnit[
                                                                  length
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col
                                              style={{ paddingRight: "5px" }}
                                              span={10}
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  label={"Allowed Limit"}
                                                  className="dBlock"
                                                  style={{ marginBottom: 0 }}
                                                >
                                                  <Input.Group compact>
                                                    <Form.Item
                                                      name={`allowed-quantity${index}`}
                                                      noStyle
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This field is required",
                                                        },
                                                        {
                                                          pattern: new RegExp(
                                                            /^(?!0+(?:\.0+)?$)\d+(\.\d{1,3})?$/
                                                          ),
                                                          message:
                                                            "Only Numeric characters greater than zero are allowed upto 3 decimal point",
                                                        },
                                                      ]}
                                                      initialValue={
                                                        stockSize.allowedQuantity
                                                      }
                                                    >
                                                      <Input
                                                        placeholder="Allowed Limit"
                                                        style={{
                                                          width:
                                                            "calc(100% - 70px)",
                                                          borderTopRightRadius: 0,
                                                          borderBottomRightRadius: 0,
                                                        }}
                                                        // onChange={(e) =>
                                                        //     onAllowedQuantityChange(
                                                        //       e.target.value,
                                                        //       stockSize.size,
                                                        //       index
                                                        //     )
                                                        //   }
                                                      />
                                                    </Form.Item>
                                                    <Form.Item
                                                      name={`allowed-quantity_unit${index}`}
                                                      noStyle
                                                      initialValue={
                                                        stockSize.units.quantity
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: 70,

                                                          borderTopLeftRadius: 0,
                                                          borderBottomLeftRadius: 0,
                                                        }}
                                                        dropdownStyle={{
                                                          minWidth: 70,
                                                        }}
                                                        suffixIcon={
                                                          <DownArrowDraw />
                                                        }
                                                        // onChange={() => {
                                                        //   form.validateFields([`allowed-quantity${index}`]);
                                                        // }}
                                                      >
                                                        {unitData.units_management.weight.data.map(
                                                          (weight) => (
                                                            <Option
                                                              key={weight}
                                                            >
                                                              {
                                                                weightUnit[
                                                                  weight
                                                                ].displayName
                                                              }
                                                            </Option>
                                                          )
                                                        )}
                                                      </Select>
                                                    </Form.Item>
                                                  </Input.Group>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                            <Col span={4}>
                                              <div
                                                className="boxFormType"
                                                style={{
                                                  marginBottom: "0",
                                                  marginTop: "33px",
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <Tooltip
                                                  title={
                                                    "Save the entered value"
                                                  }
                                                >
                                                  <Button
                                                    key="1"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                      marginRight: "10px",
                                                    }}
                                                    onClick={() =>
                                                      onSaveChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="check"
                                                      size={18}
                                                      color="#3FBD61"
                                                    />
                                                  </Button>
                                                </Tooltip>

                                                <Tooltip
                                                  title={"Delete the stock"}
                                                >
                                                  <Button
                                                    key="2"
                                                    className="edit-btn"
                                                    style={{
                                                      padding: "0px",
                                                      margin: "0px",
                                                      width: "28px",
                                                      border: "none",
                                                      display: "inline-block",
                                                    }}
                                                    onClick={() =>
                                                      onDiscardChages(index)
                                                    }
                                                  >
                                                    <Iconmoon
                                                      icon="cancel"
                                                      size={18}
                                                      color="red"
                                                    />
                                                  </Button>
                                                </Tooltip>
                                              </div>
                                            </Col>
                                          </Row>
                                           
                                          </>
                                        )}
                                        {isDynamicStock &&
                                          index == stockSizes.length - 1 && (
                                            <GlobalSet
                                              style={{ marginTop: "20px",
                                                 display: "flex",
                                                flexWrap: "wrap",   // makes it responsive (wraps on small screens)
                                                gap: "16px", }}
                                            >
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                  
                                                }}
                                                onClick={onAddStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add new stock
                                              </Button>
                                              <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddRequiredStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add required stock
                                              </Button>
                                            </GlobalSet>
                                          )}
                                      </Row>
                                    );
                                  })}
                                  {isDynamicStock && !stockSizes.length && (
                                    <GlobalSet
                                      style={{
                                        marginTop: "20px",
                                        display: "flex",
                                        flexWrap: "wrap",   // makes it responsive (wraps on small screens)
                                        gap: "16px", 
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <Button
                                        className="textTypeBtn textBtnIcon"
                                        style={{
                                          marginLeft: "0",
                                          background: "none",
                                        }}
                                        onClick={onAddStock}
                                      >
                                        <Iconmoon
                                          icon="addcircle"
                                          size={14}
                                          color="#EA655B"
                                        />
                                        Add new stock
                                      </Button>
                                      <Button
                                                className="textTypeBtn textBtnIcon"
                                                style={{
                                                  marginLeft: "0",
                                                  background: "none",
                                                }}
                                                onClick={onAddRequiredStock}
                                              >
                                                <Iconmoon
                                                  icon="addcircle"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                                Add required stock
                                              </Button>
                                    </GlobalSet>
                                  )}
                                </>
                              </Col>
                            </Row>
                          </PaperBlockList>
                        </Col>
                      </Row>
                    </div>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Machine Details" key="2">
                <DetailFields>
                  <HaberForm>
                    <div className="groupDetailWrap">
                      <Row gutter={[24]} className="groupForm">
                        <Col span={24} className="blockBreak">
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle removeStar">
                                  <label>Deckle Range</label>
                                  <p>
                                    Specify the minimum and maximum deckle
                                    length of the machine
                                  </p>
                                </div>
                              </Col>
                              <Col span={12} className="d-flex threeFields">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="min_deckle_length"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.min_deckle_length
                                    }
                                    label="Min Deckle Length"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Min Deckle Length"
                                      onChange={() => {
                                        console.log("Something changed");
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="max_deckle_length"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.max_deckle_length
                                    }
                                    label="Max Deckle Length"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Min Deckle Length"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType unitSelect"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="deckleLengthUnit"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                    ]}
                                    label="Unit"
                                    className="dBlock"
                                    initialValue={
                                      formValuesForStock?.deckleLengthUnit
                                    }
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    >
                                      {unitData.units_management.length.data.map(
                                        (deckleWidth) => (
                                          <Option key={deckleWidth}>
                                            {
                                              lengthUnit[deckleWidth]
                                                .displayName
                                            }
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                    {/* <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                      }}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select> */}
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle removeStar">
                                  <label>Edge Trim</label>
                                  <p>
                                    Specify the left and right edge trim for the
                                    machine
                                  </p>
                                </div>
                              </Col>
                              <Col span={12} className="d-flex threeFields">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="min_width"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.left_edge_trim
                                    }
                                    label="Left Trim"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Left trim"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="max_width"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only numerical values are allowed",
                                      },
                                    ]}
                                    initialValue={
                                      formValuesForStock?.right_edge_trim
                                    }
                                    label="Right Trim"
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Right trim"
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  className="boxFormType unitSelect"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    name="widthUnit"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This is a required field",
                                      },
                                    ]}
                                    label="Unit"
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={() => {
                                        changeDeckleLength();
                                      }}
                                    >
                                      {unitData.units_management.length.data.map(
                                        (deckleWidth) => (
                                          <Option key={deckleWidth}>
                                            {
                                              lengthUnit[deckleWidth]
                                                .displayName
                                            }
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <PaperBlockList>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Effective Deckle Length</label>
                                  <p>
                                    Available deckle length to match deckle
                                    after adjusting for edge trim
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name="effective_deckle_length"
                                    className=""
                                    initialValue={
                                      formValuesForStock?.effective_deckle_length
                                    }
                                    shouldUpdate
                                  >
                                    <Input
                                      disabled
                                      placeholder="Enter Deckle Length"
                                      suffix={
                                        <label className="floating-label">
                                          {lengthUnit[deckleUnit].displayName}
                                        </label>
                                      }
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </PaperBlockList>
                          <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Maximum Number of cutters</label>
                                <p>
                                  Specify maximum number of cutters including
                                  edge cutters which can be placed on deckle
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="cutters"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This is a required field",
                                    },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d+)?$/),
                                      message:
                                        "Only numerical values are allowed",
                                    },
                                  ]}
                                  initialValue={
                                    formValuesForStock?.maximum_cutters
                                  }
                                  className=""
                                >
                                  <Input placeholder="Maximum Number of cutters" />
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </HaberForm>
                </DetailFields>
              </Panes>
              <Panes tab="Completed Orders" key="5">
                <>
                  <TableLayoutData>
                    <div className="tableDataFormat ">
                      {loading ? (
                        <TableShimmer
                          // header={
                          //   location?.state?.processType === "multiStage"
                          //     ? columnsHead
                          //     : location?.state?.selected_type === "cutting"
                          //     ? columnsHeadForSheets
                          //     : columnsHead.filter((col) => col.title !== "Grain")
                          // }
                          header={columnsHead}
                          scroll={2000}
                        />
                      ) : completedOrders.length ? (
                        <Table
                          // columns={
                          //   location?.state?.processType === "multiStage"
                          //     ? columnsHead
                          //     : columnsHead.filter((col) => col.title !== "Grain")
                          // }
                          columns={columnsHead}
                          dataSource={completedOrders}
                          scroll={{ x: "max-content" }}
                        />
                      ) : (
                        <EmptyState
                          img={
                            emptyStateLabel === "noData" ||
                            emptyStateLabel === "filter"
                              ? emptyState_NoData
                              : emptyStateLabel === "search"
                              ? emptyState_Search
                              : emptyState_ConnectionAPIError
                          }
                          heading={emptyStatePropsData?.heading}
                          subHeading={emptyStatePropsData?.subHeading}
                          label={emptyStatePropsData?.label}
                          refresh={refresh}
                        />
                      )}
                    </div>
                  </TableLayoutData>
                </>
              </Panes>
              <Panes tab="Orders" key="3">
                <OrdersTable
                  ordersIdList={ordersIdList}
                  isJobCardReelODEditModal={isJobCardReelODEditModal}
                  setJobCardReelODEditModal={setJobCardReelODEditModal}
                  // jobCardDetails={jobCardDetails}
                  unselectedOrdersList={unselectedOrders}
                  groupId={jobCardDetails?.group?.group_id}
                  machineData={machineData}
                  jobId={jobId}
                  jobCardDetails={
                    ((solutionId == "3" || solutionId == "4") && completeJCDetails.newlyCreatedJobCardsDetails?.[0])
                      ? completeJCDetails.newlyCreatedJobCardsDetails?.[0]?.jobcard
                      : jobCardDetails
                  }
                  updateOrderIdList={(updatedOrderIds) => {
                    setOrderIdList(updatedOrderIds);
                    updateOrdersIdList && updateOrdersIdList(updatedOrderIds);
                  }}
                  onClickSetToleranceButton={onClickSetToleranceButton}
                  visible={toleranceModal}
                  setGlobalTolerance={setGlobalTolerance}
                  globalTolerance={globalTolerance}
                  setShowAlert={setShowAlert}
                  showAlert={showAlert}
                  setGlobalReelOD={setGlobalReelOD}
                  dummy_orders = {dummy_orders}
                  so_number= {so_number}
                />
              </Panes>
              <Panes tab="Optimization Settings" key="4">
                <DetailFields>
                  <HaberForm>
                    <Row style={{ margin: "20px 0 0 10px" }}>
                      <Col span={12}>
                        <label>
                          <h2>Optimization Criteria</h2>
                        </label>
                        <span>
                          Select the optimization criteria for creating a new
                          solution
                        </span>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "61vh",
                        }}
                      >
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Unique Combinations</label>
                            <Col span={20}>
                              <p>
                                You can choose to minimize the number of unique
                                combinations and save on setup time by enabling
                                this optimization criteria.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <Switch
                              style={{
                                backgroundColor: optimizePartition
                                  ? "#EA655B"
                                  : "#A19F9D",
                              }}
                              onChange={handleSwitchChange2}
                              checked={optimizePartition}
                              className="switch-new"
                            />
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Trim Loss</label>
                            <Col span={20}>
                              <p>
                                The system tries to minimize trim loss by
                                default.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <div className="boxFormType">
                              {/* <Form.item
                                name="optimizie_partitions"
                                // initialValue={optimizePartition}
                              > */}
                              <Switch
                                style={{
                                  backgroundColor: "#EA655B",
                                }}
                                className="switch-new"
                                disabled
                                checked={true}
                              />{" "}
                              {/* </Form.item> */}
                            </div>
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Maximize Fulfilment</label>
                            <Col span={20}>
                              <p>
                                The system tries to maximize fulfilment by
                                default.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <div className="boxFormType">
                              <Switch
                                style={{
                                  backgroundColor: "#EA655B",
                                }}
                                disabled
                                checked={true}
                                className="switch-new"
                              />{" "}
                            </div>
                          </Col>
                        </Row>
                        <Row
                          style={{ alignItems: "center", marginBottom: "10px" }}
                        >
                          <Col span={18}>
                            <label>Minimize Overfulfilment</label>
                            <Col span={20}>
                              <p>
                                You can choose to minimize over fulfilment by
                                enabling this optimization criteria but it might
                                affect your fulfilment percentage, number of
                                combinations or trim loss.
                              </p>
                            </Col>
                          </Col>
                          <Col span={6} style={{ textAlign: "right" }}>
                            <Switch
                              style={{
                                backgroundColor: minimizeOverfulfillment
                                  ? "#EA655B"
                                  : "#A19F9D",
                              }}
                              onChange={handleSwitchChange3}
                              checked={minimizeOverfulfillment}
                              className="switch-new"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </HaberForm>
                </DetailFields>
              </Panes>
            </Tabs>
          </StyledTab>
        </div>
      </Form>
      {errorToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"Invalid entries for a stock."}
        />
      )}

      {sizeErrorToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"Stock size already exist."}
        />
      )}
      {orderToastr && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={"At least one order need to exist in a solution."}
        />
      )}
    </RightLayoutContainer>
  ) : null;
};
export default CreateNewSolution;